import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://62fcf559190f1e0d0647cc2d24edabd5@o4509961190572032.ingest.de.sentry.io/4510260955185233',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 0.2,
  environment: 'production',
});

export { Sentry };
